"use client";

import Toast from "@/components/design-system/toast";
import { hideCartToast } from "@/store/shoppingCartSlice";
import { AppState } from "@/store/store";
import { useSelector } from "react-redux";

const CartToast = () => {
  const showToast = useSelector((state: AppState) => state.shoppingCartSlice.showToast);
  const toastMessage = useSelector((state: AppState) => state.shoppingCartSlice.toastMessage);
  const toastSubMessage = useSelector((state: AppState) => state.shoppingCartSlice.toastSubMessage);
  const toastType = useSelector((state: AppState) => state.shoppingCartSlice.toastType);
  const showCheckoutLink = useSelector((state: AppState) => state.shoppingCartSlice.showCheckoutLink);

  return (
    <Toast
      linkText={showCheckoutLink && toastType === "success" ? "Proceed to Checkout" : undefined}
      linkHref={showCheckoutLink && toastType === "success" ? "/checkout" : undefined}
      toastMessage={toastMessage}
      toastSubMessage={toastSubMessage}
      showToast={showToast}
      toastType={toastType}
      hideToast={hideCartToast}
      showCloseButton
      showOnMobile
      showToastTime={6000}
      toastLocation="top"
    />
  );
};

export default CartToast;
